var _rect, _rect2, _line, _line2, _line3, _line4, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFq28(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.803906,
    y: 0.796094,
    width: 48.972,
    height: 48.972,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.0402,
    y: 12.0305,
    width: 26.4993,
    height: 26.4993,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 38.6277,
    y1: 12.1824,
    x2: 49.864,
    y2: 0.946085,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.953884,
    y1: 49.8543,
    x2: 12.1902,
    y2: 38.618,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 38.3899,
    y1: 38.6199,
    x2: 49.6262,
    y2: 49.8562,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0.716038,
    y1: 0.944118,
    x2: 11.9524,
    y2: 12.1804,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.714 30.23C19.4313 28.942 20.7567 27.7893 21.69 26.772C22.6327 25.7453 23.104 24.742 23.104 23.762C23.104 23.118 22.9407 22.6047 22.614 22.222C22.2967 21.83 21.774 21.634 21.046 21.634C20.3367 21.634 19.786 21.858 19.394 22.306C19.0113 22.7447 18.7967 23.3327 18.75 24.07H17.798C17.854 23.034 18.1713 22.2313 18.75 21.662C19.338 21.0833 20.1033 20.794 21.046 20.794C21.9513 20.794 22.684 21.0507 23.244 21.564C23.804 22.068 24.084 22.7867 24.084 23.72C24.084 24.8493 23.6127 25.946 22.67 27.01C21.7367 28.0647 20.584 29.096 19.212 30.104H24.392V30.93H17.714V30.23ZM27.8677 25.792C27.2891 25.6053 26.8457 25.3113 26.5377 24.91C26.2391 24.5087 26.0897 24.0233 26.0897 23.454C26.0897 22.95 26.2157 22.502 26.4677 22.11C26.7291 21.7087 27.1071 21.396 27.6017 21.172C28.0964 20.9387 28.6891 20.822 29.3797 20.822C30.0704 20.822 30.6631 20.9387 31.1577 21.172C31.6524 21.396 32.0257 21.7087 32.2777 22.11C32.5391 22.502 32.6697 22.95 32.6697 23.454C32.6697 24.014 32.5157 24.4993 32.2077 24.91C31.9091 25.3207 31.4704 25.6147 30.8917 25.792C31.5264 25.9507 32.0257 26.254 32.3897 26.702C32.7537 27.15 32.9357 27.696 32.9357 28.34C32.9357 28.9373 32.7864 29.46 32.4877 29.908C32.1984 30.3467 31.7831 30.6873 31.2417 30.93C30.7097 31.1727 30.0891 31.294 29.3797 31.294C28.6704 31.294 28.0451 31.1727 27.5037 30.93C26.9717 30.6873 26.5564 30.3467 26.2577 29.908C25.9684 29.46 25.8237 28.9373 25.8237 28.34C25.8237 27.696 26.0057 27.15 26.3697 26.702C26.7337 26.254 27.2331 25.9507 27.8677 25.792ZM31.7177 23.566C31.7177 22.95 31.5077 22.474 31.0877 22.138C30.6677 21.802 30.0984 21.634 29.3797 21.634C28.6611 21.634 28.0917 21.802 27.6717 22.138C27.2517 22.4647 27.0417 22.9407 27.0417 23.566C27.0417 24.1447 27.2564 24.6067 27.6857 24.952C28.1151 25.2973 28.6797 25.47 29.3797 25.47C30.0797 25.47 30.6444 25.2973 31.0737 24.952C31.5031 24.6067 31.7177 24.1447 31.7177 23.566ZM29.3797 26.226C28.6144 26.226 27.9891 26.3987 27.5037 26.744C27.0184 27.0893 26.7757 27.612 26.7757 28.312C26.7757 28.984 27.0091 29.5113 27.4757 29.894C27.9424 30.2767 28.5771 30.468 29.3797 30.468C30.1731 30.468 30.8031 30.2767 31.2697 29.894C31.7364 29.502 31.9697 28.9747 31.9697 28.312C31.9697 27.6213 31.7271 27.1033 31.2417 26.758C30.7657 26.4033 30.1451 26.226 29.3797 26.226Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFq28);
export default __webpack_public_path__ + "static/media/fq28.888027154539cd7c134d855d3e917078.svg";
export { ForwardRef as ReactComponent };